import * as React from 'react'
import { TaskSizeListConnected } from './TaskSizeListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskSizeListExamples = () => {
  return (
    <div className="TaskSizeListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskSizeListConnected />
      </Provider>
    </div>
  )
}
